export default "__VITE_ASSET__eYmPgPCk__"